import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { BYPASS_ERROR_INTERCEPTOR } from './bypass-error-interceptor.token';

interface IDefaultError {
  message: string;
  error: string;
}
interface IServerError {
  error?: string;
  message?: string | { error: string; message: string };
  statusCode?: number;
}
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private toastr = inject(ToastrService);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (request.context.get(BYPASS_ERROR_INTERCEPTOR)) {
          return throwError(() => errorResponse);
        }

        this.spinner.hide();
        const DEFAULT_ERROR: IDefaultError = {
          message: 'Kérem vegye fel a kapcsolatot velünk!',
          error: 'Váratlan hiba!',
        };

        if (!errorResponse?.error) {
          this.toastr.error(DEFAULT_ERROR.message, DEFAULT_ERROR.error);
          return throwError(() => new Error(DEFAULT_ERROR.error));
        }

        const { message, error } = errorResponse.error as IServerError;
        const { status } = errorResponse;
        const finalError = error
          ? error
          : typeof message !== 'string'
            ? message?.error
            : DEFAULT_ERROR.error;
        const finalMessage =
          typeof message === 'string'
            ? message
            : message?.message
              ? message?.message
              : DEFAULT_ERROR.message;

        if (errorResponse.error instanceof ErrorEvent) {
          this.toastr.error(finalMessage, finalError);
          return throwError(() => new Error(finalError));
        }
        switch (status) {
          case 400:
            this.toastr.error(finalMessage, 'Helytelen formátum!');
            break;
          case 401:
            this.toastr.error('', 'Sikertelen azonosítás!');
            this.router.navigate(['/login']);
            break;
          case 403:
            this.toastr.error(finalMessage, 'Hozzáférés megtagadva!');
            this.router.navigate(['/access-denied'], { state: { returnUrl: this.router.url } });
            break;
          case 500:
            this.toastr.error(finalMessage, finalError);
            break;
        }
        return throwError(() => errorResponse.error);
      })
    );
  }
}
